<template>
  <div>
    <img src="@/assets/img/in/banner.png" style="width: 100%;" alt="" />
    <!--  -->
    <div class="module">
      <div class="title">
        <div class="title_en">CORE STRENGTHS</div>
        <div class="title_cn">加入云鸟快采6大核心优势</div>
      </div>
      <div class="core" style="margin-top: 0.6rem;">
        <div class="core-item">
          <div class="title">智能管理系统</div>
          <div class="desc">
            查看供销存、线上提醒订单、自动引流客户、完整数据统计、运营活动、客户管理
          </div>
        </div>
        <div class="core-item">
          <div class="title">整体销售方案</div>
          <div class="desc">
            云鸟销售团队多年一线辅材销售经验，提供整体运营案件
          </div>
        </div>
        <div class="core-item">
          <div class="title">传统辅材转型服务型</div>
          <div class="desc">
            全品一站式服务平台，云鸟平台帮助完成服务转型，从仓储物流到客服后台指导
          </div>
        </div>
      </div>
      <div class="core">
        <div class="core-item">
          <div class="title">全国统一形象店</div>
          <div class="desc">
            统一宣传、如天猫小店，统一店招，统一服务标准。提升商家形象
          </div>
        </div>
        <div class="core-item">
          <div class="title">完整供应链体系输出</div>
          <div class="desc">
            水电木瓦油全品全系列输出高毛利、易推广产品、厂家、云鸟双重协助销售
          </div>
        </div>
        <div class="core-item">
          <div class="title">金融服务</div>
          <div class="desc">上游产品账期服务、C端客户信用白条服务</div>
        </div>
      </div>
    </div>

    <div class="module">
      <div class="title">
        <div class="title_cn">招商加盟</div>
      </div>
      <div class="form" style="margin-top: 0.5rem">
        <div class="l-input">
          <label for="area">意向地区</label>
          <input
            placeholder="请选择地区"
            :value="form.intention_city_name"
            disabled
            type="text"
            name="area"
            id="area"
          />
          <div class="select-button" @click="areaShow = true">选择地区</div>
        </div>
        <div class="l-input">
          <label for="user">联系人</label>
          <input
            v-model="form.link_name"
            placeholder="请输入联系人姓名"
            type="text"
            name="user"
            id="user"
          />
        </div>
        <div class="l-input">
          <label for="phone">联系电话</label>
          <input v-model="form.link_telephone" placeholder="请输入电话" type="text" name="phone" id="phone" />
        </div>

        <div class="submit" @click="submit">确定加入</div>
      </div>
    </div>
    <div class="mask" v-show="areaShow">
      <div class="area">
        <img @click="areaShow = false; areaview = area;" class="close" src="@/assets/img/in/close.png" alt="">
        <div
          class="area-item"
          :class="{
            'area-item-sel': currentArea && currentArea.area_id == item.area_id
          }"
          @click="selectArea(item,index)"
          v-for="(item, index) in areaview"
          :key="item.area_id"
        >
          {{ item.area_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "",
  data() {
    return {
      areaShow: false,
      area: [],
      areaview: [],
      currentArea: {
          area_name: '',
          area_id: '',
          city_name: '',
          city_id: ''
      },
      form: {
          intention_city_name: '',
          intention_city_id: '',
          link_name: '',
          link_telephone: ''
      }
    };
  },
  created() {
    let self = this;
    axios.post("/api/area", {}).then(res => {
      if (res.data.code == 200) {
        self.area = res.data.data;
        self.areaview = res.data.data;
      }
    });
  },
  methods: {
    selectArea(area, index) {
      if (this.currentArea.area_id){
        this.form.intention_city_name = area.area_name;
        this.form.intention_city_id = area.area_id;
        this.currentArea.city_id = area.area_id;
        this.currentArea.city_name = area.area_name;
        this.currentArea.area_id = '';
        this.currentArea.area_name = '';
        this.areaShow = false;
        this.areaview = this.area;
      }else{
        this.currentArea.area_id = area.area_id;
        this.currentArea.area_name = area.area_name;
        this.areaview = this.area[index].name;
      }
    },
    submit() {
      let self = this,
        valid = true,
        phonevalid = true;

    Object.keys(this.form).forEach(res => {
        if (!self.form[res]) {
          valid = false;
        }
        if (res == 'link_telephone' && self.form[res].length != 11){
          phonevalid = false;
        }
      });

      if (!phonevalid){
        alert('请输入正确的手机号')
        return;
      }

      if (!valid) {
        alert("请完善信息");
        return;
      }
      
      axios.post("/api/intention", this.form).then(res => {
        if (res.data.code == 200) {
          alert("提交成功");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.module {
  margin: 1rem 0;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 0.22rem;
}

.l-input {
  margin: 0.08rem 0;
  position: relative;
  display: flex;
  align-items: center;
}

.select-button {
  width: 1.2rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  background: rgba(55, 148, 252, 1);
  border-radius: 0.24rem;
  position: absolute;
  color: #ffffff;
  right: -1px;
  font-size: 0.2rem;
  cursor: pointer;
}

.submit {
  width: 1.68rem;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  background: rgba(55, 148, 252, 1);
  border-radius: 0.24rem;
  color: #ffffff;
  font-size: 0.2rem;
  cursor: pointer;
  margin-top: 0.4rem;
}

label {
  font-size: 0.2rem;
  color: #333333;
  width: 1rem;
  display: inline-block;
}
input {
  font-size: 0.2rem;
  color: #333333;
  height: 0.48rem;
  padding: 0 0.3rem;
  -webkit-border-radius: 0.24rem;
  -moz-border-radius: 0.24rem;
  border-radius: 0.24rem;
  outline: none;
  border: 1px solid #979797;
  width: 3.4rem;
}

.core {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2.4rem;
  .core-item {
    cursor: pointer;
    margin: 0.15rem;
    border: 1px solid #3794fc;
    width: 3.8rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
      background-color: #3794fc;
      .title {
        color: #ffffff;
      }
      .desc {
        color: #ffffff;
      }
    }
    .title {
      font-size: 0.24rem;
      color: #333333;
      line-height: 0.28rem;
      margin-bottom: 0.3rem;
    }
    .desc {
      width: 3rem;
      height: 0.4rem;
      font-size: 0.18rem;
      color: #8c8c8c;
      // line-height: 0.2rem;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999999999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  .area {
    width: 50%;
    max-height: 50%;
    background-color: white;
    border-radius: 10px;
    padding: 0.3rem;
    display: flex;
    flex-wrap: wrap;
    overflow: scroll;
    position: relative;
    padding-top: .9rem;
    .close{
      position: absolute;
      width: .4rem;
      height: .4rem;
      right: .4rem;
      top: .2rem;
      cursor: pointer;
    }
    .area-item {
      cursor: pointer;
      margin: 0.1rem 0.1rem;
      height: .6rem;
      overflow: hidden;
      line-height: .6rem;
      width: 1.4rem;
      text-align: center;
      font-size: 0.2rem;
      color: #333333;
      background-color: #eeeeee;
    }

    .area-item-sel {
      color: white;
      background-color: #3794fc;
    }
  }
}

@media screen and (max-width: 800px){
  .core{
    flex-direction: column;
    padding: 0;
    .core-item{
      width: 4.8rem;
      .title{
        // font-size: .26rem;
      }
      .desc{
        height: auto;
        font-size: .2rem;
      }
    }
  }

  .module .title_en{
    font-size: .2rem;
  }

  .module .title_cn{
    font-size: 0.3rem;
    line-height: 0.38rem;
  }
}
</style>
